import { useLocation, useNavigate } from "react-router-dom";
import { LayoutGrid, FolderKanban, FolderTree, Settings } from "lucide-react";

const TABS = [
    { id: "dashboard", label: "Dashboard", icon: LayoutGrid,   path: "/portal" },
    { id: "projects",  label: "Projects",  icon: FolderKanban, path: "/portal/projects" },
    { id: "workspace", label: "Workspace", icon: FolderTree,   path: "/portal/workspace" },
    { id: "settings",  label: "Settings",  icon: Settings,     path: "/portal#settings" },
];

export default function BottomTabNav() {
    const loc = useLocation();
    const nav = useNavigate();

    const isActive = (path) => {
        if (path.startsWith("/portal/")) return loc.pathname.startsWith(path);
        return loc.pathname === "/portal" || loc.pathname === "/portal/";
    };

    return (
        <nav
            data-testid="portal-bottom-tab"
            className="
                lg:hidden fixed bottom-0 inset-x-0 z-40
                bg-tca-bg-deep/95 backdrop-blur-xl border-t border-tca-cyan/22
                grid grid-cols-4
            "
            style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
        >
            {TABS.map((t) => {
                const Icon = t.icon;
                const active = isActive(t.path);
                return (
                    <button
                        key={t.id}
                        type="button"
                        onClick={() => nav(t.path)}
                        data-testid={`bottom-tab-${t.id}`}
                        className={`
                            flex flex-col items-center justify-center gap-1 py-3
                            font-mono-tight text-[9px] uppercase tracking-[0.22em]
                            transition-colors duration-300
                            ${active ? "text-tca-cyan-hi" : "text-tca-ink-muted hover:text-tca-cyan"}
                        `}
                    >
                        <Icon size={18} strokeWidth={active ? 2 : 1.5} />
                        <span>{t.label}</span>
                    </button>
                );
            })}
        </nav>
    );
}
